(function () {
  const ROOT_SELECTOR = '.bm-collection-header-2-slot';
  const WRAPPER_SELECTOR = '.facets__filters-wrapper';
  const SCROLLER_SELECTOR = '.bm-facets-scroll-list';
  const PANEL_SELECTOR = '.facets__panel';
  const OPEN_CLASS = 'bm-facets-has-open-panel';
  const DESKTOP_QUERY = '(min-width: 990px)';

  let restoreFrame = null;

  function isDesktopHeader2() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function clearPendingRestore() {
    if (restoreFrame) {
      window.cancelAnimationFrame(restoreFrame);
      restoreFrame = null;
    }
  }

  function restoreScrollLeft(scroller, scrollLeft) {
    if (!scroller || scrollLeft === null || scrollLeft === undefined) return;

    scroller.scrollLeft = scrollLeft;
  }

  function scheduleScrollRestore(scroller, scrollLeft) {
    clearPendingRestore();

    restoreFrame = window.requestAnimationFrame(() => {
      restoreFrame = null;
      restoreScrollLeft(scroller, scrollLeft);
      window.requestAnimationFrame(() => restoreScrollLeft(scroller, scrollLeft));
    });

    window.setTimeout(() => restoreScrollLeft(scroller, scrollLeft), 0);
    window.setTimeout(() => restoreScrollLeft(scroller, scrollLeft), 40);
    window.setTimeout(() => restoreScrollLeft(scroller, scrollLeft), 100);
    window.setTimeout(() => restoreScrollLeft(scroller, scrollLeft), 180);
  }

  function closeSiblingPanels(scroller, activePanel) {
    scroller.querySelectorAll(`${PANEL_SELECTOR}[open]`).forEach((panel) => {
      if (panel !== activePanel) {
        panel.open = false;
      }
    });
  }

  function manuallyTogglePanel(summary) {
    if (!isDesktopHeader2() || !summary) return;

    const panel = summary.closest(PANEL_SELECTOR);
    const scroller = summary.closest(SCROLLER_SELECTOR);

    if (!panel || !scroller) return;

    const scrollLeft = scroller.scrollLeft;
    const shouldOpen = !panel.open;

    closeSiblingPanels(scroller, panel);
    panel.open = shouldOpen;

    syncOpenState(panel);
    scheduleScrollRestore(scroller, scrollLeft);
  }

  function syncOpenState(scope) {
    const root = scope?.closest?.(ROOT_SELECTOR) || document;

    root.querySelectorAll(`${ROOT_SELECTOR} ${WRAPPER_SELECTOR}`).forEach((wrapper) => {
      wrapper.classList.toggle(OPEN_CLASS, Boolean(wrapper.querySelector(`${PANEL_SELECTOR}[open]`)));
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!isDesktopHeader2()) return;

      const summary = event.target.closest(`${ROOT_SELECTOR} ${SCROLLER_SELECTOR} summary`);

      if (!summary) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      manuallyTogglePanel(summary);
    },
    true
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (!isDesktopHeader2() || (event.key !== 'Enter' && event.key !== ' ')) return;

      const summary = event.target.closest(`${ROOT_SELECTOR} ${SCROLLER_SELECTOR} summary`);

      if (!summary) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      manuallyTogglePanel(summary);
    },
    true
  );

  document.addEventListener(
    'toggle',
    (event) => {
      if (!event.target.matches(`${ROOT_SELECTOR} ${PANEL_SELECTOR}`)) return;

      syncOpenState(event.target);
    },
    true
  );

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') {
      clearPendingRestore();
      window.setTimeout(() => syncOpenState(document), 0);
    }
  });

  window.addEventListener('resize', () => {
    clearPendingRestore();
    syncOpenState(document);
  });

  document.addEventListener('shopify:section:load', () => {
    clearPendingRestore();
    syncOpenState(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncOpenState(document), { once: true });
  } else {
    syncOpenState(document);
  }
})();
